import { createFileRoute } from "@tanstack/react-router";

import ShipMetalLayout from "./-components/ShipMetal/ShipMetalLayout";

export const Route = createFileRoute("/_authenticated/trade/ship-metal")({
  component: ShipMetalLayout,
  context: () => ({ permissions: "trade.ship" }),
});
